import { get, post, patch,deleted } from 'services';
import routes from './routes';

const VehicleBookingServices = {
  getVehicleBookingFilter: async () => {
    const data = await get(routes.getVehicleBookingFilter);
    return data;
  },
    getTimeline: async (params) => {
    const data = await get(routes.getTimeline,params);
    return data;
  },
  getTaxation: async (params) => {
    const data = await get(routes.getTaxation, params);
    return data;
  },
    getMasterReport: async (params) => {
    const data = await get(routes.getMasterReport, params);
    return data;
  },
  getVehicleBookings: async (params) => {
    const data = await get(routes.getVehicleBookings, params);
    return data;
  },
    getVehicleBookings2: async (params) => {
    const data = await get(routes.getVehicleBookings2, params);
    return data;
  },
    getVinDetail: async (params) => {
    const data = await get(routes.getVinDetail, params);
    return data;
  },
  getVehicleBookingDetail: async (params) => {
    const data = await get(routes.getVehicleBookingDetail, params);
    return data;
  },
  createVehicleBooking: async (obj) => {
    const data = await post(routes.createVehicleBooking, obj);
    return data;
  },
    deleteBooking: async (obj) => {
    const data = await deleted(routes.deleteBooking, obj);
    return data;
  },
  updateVehicleBooking: async (obj) => {
    const data = await patch(routes.updateVehicleBooking, obj);
    return data;
  },
    deleteVehicle: async (obj) => {
    const data = await deleted(routes.deleteVehicle, obj);
    return data;
  },
  getMissingFields: async (params) => {
    const data = await get(routes.getMissingFields, params);
    return data;
  },
  updateMissingFieldVehicleBooking: async (obj) => {
    const data = await patch(routes.updateMissingFieldVehicleBooking, obj);
    return data;
  },
  getApprovalList: async (params) => {
    const data = await get(routes.getApprovalList, params);
    return data;
  },
  getApprovalDetail: async (params) => {
    const data = await get(routes.getApprovalDetail, params);
    return data;
  },
  reviewApproval: async (obj) => {
    const data = await post(routes.reviewApproval, obj);
    return data;
  },
   updateBookingStatus: async (obj) => {
    const data = await post(routes.updateBookingStatus, obj);
    return data;
  },
  getBookingCustomers: async (params) => {
    const data = await get(routes.getBookingCustomers, params);
    return data;
  },
}

export default VehicleBookingServices